'use client'

import Link from 'next/link'
import { Button } from '@heroui/react'

import { CONTACT_PATHS } from '@/config/contact'
import { useFeatureFlags } from '@/lib/features/feature-flags-context'

export interface CTAProps {
  href?: string
  children: React.ReactNode
}

export function CTA({ href = '/book', children }: CTAProps) {
  const { bookingEnabled } = useFeatureFlags()
  // Content pages default to the booking wizard; while booking is off every
  // /book link becomes the quote form (the wizard itself redirects there too).
  const target = !bookingEnabled && href.startsWith('/book') ? CONTACT_PATHS.quote : href
  return (
    <div className="my-8 flex justify-center">
      {/* Wrap Button in Link: HeroUI v3 `as={Link}` drops the brand variant, rendering an
          unstyled (invisible-in-dark) button. See project memory. */}
      <Link href={target} className="inline-flex no-underline">
        <Button variant="primary" size="lg">
          {children}
        </Button>
      </Link>
    </div>
  )
}
